// The signed-in member's role in this workspace, for hiding controls the
// server would refuse. The server stays the authority (requireRole); this only
// stops the UI offering a button that can only end in "Role agent not allowed".
//
// Reads /api/team/members under the same query key as the Billing page's
// signature section, so the two share one request.

import { useAuth } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type MemberRole = 'owner' | 'admin' | 'agent' | 'viewer';

export function useMyRole(): MemberRole | null {
  const { getToken } = useAuth();
  const { data } = useQuery({
    queryKey: ['team-members'],
    queryFn: () =>
      api<{ members: Array<{ isSelf: boolean; role: MemberRole }> }>('/api/team/members', { tokenGetter: () => getToken() }),
    staleTime: 30_000,
  });
  return data?.members.find((m) => m.isSelf)?.role ?? null;
}

/** Owner or admin: may issue legal documents such as a commercial invoice. */
export const isElevated = (role: MemberRole | null) => role === 'owner' || role === 'admin';
